module.exports = __webpack_public_path__ + "media/images/pic/home/pride-e9af1dafcd86f7551da83da8dacffc11.png";